import React, { useState, useEffect, Fragment, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import groupService from '../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TotalCropReportTable } from "../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { exportTagDetailsSchema } from "../exportTagDetailsSchema";
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import '../../Common/Table/table.css';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import _, { flatMap } from 'lodash';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Icon from '@material-ui/core/Icon';

const screenCode = 'TAGDETAILS'
const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 500,
      backgroundColor: theme.palette.background.paper,
    },
  }));
export function ExportTagDetails(props) {
    const classes = useStyles();
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        tagNumber: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(exportTagDetailsSchema).options({ allowUnknown: true });
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [isViewTable, setIsViewTable] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });

    const [tagNumberValues, setTagNumberValues] = useState({
        buyerName: '',
        createdDate: '',
        dueDate: '',
        grossAmount: '',
        invoiceDate: '',
        measuringUnit: '',
        orderNumber: '',
        product: '',
        supplierName: '',
        tagNo: '',
        netAmount: ''
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTAGDETAILS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, exportTagDetailsSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {
        const reportData = await service.GetExportTagDetails(searchData.operationEntityID, searchData.tagNumber);
        if (reportData != null) {
            setIsTableHide(false);
            setTagNumberValues({
                ...tagNumberValues,
                buyerName: reportData.buyerName,
                createdDate: reportData.createdDate.split("T")[0],
                dueDate: reportData.dueDate.split("T")[0],
                grossAmount: reportData.grossAmount,
                invoiceDate: reportData.invoiceDate.split("T")[0],
                measuringUnit: reportData.measuringUnit,
                orderNumber: reportData.orderNumber,
                product: reportData.product,
                supplierName: reportData.supplierName,
                tagNo: reportData.tagNo,
                netAmount: reportData.netAmount
            })
            setSelectedSearchData();
        }
        else {
            setIsTableHide(true);
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            month: searchData.month
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Tag Details"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="tagNumber"
                                        label="Tag Number *"
                                        name="tagNumber"
                                        fullWidth
                                        value={searchData.tagNumber}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["tagNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tagNumber"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                        </form>
                        <Divider />
                        {isTableHide ? null :
                        <Grid>
 <Grid spacing={12} >
                                    <Grid item style={{ textAlign: "center" }} >
                                        <Typography style={{ fontWeight: "bold" }} gutterBottom>
                                            Tag Number : {tagNumberValues.tagNo}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br/>
                        <Grid container spacing={1}>
                        <Grid item md={2} xs={12} ></Grid>
                            <Grid item md={4} xs={12} >
                                <List style={{ textAlign: "center"}}  className={classes.root}>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>shopTwo</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-wifi" style={{ fontWeight: "bold" }} primary="Buyer" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.buyerName}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>publish</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-wifi" style={{ fontWeight: "bold" }} primary="Supplier" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.supplierName}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>update</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-wifi" style={{ fontWeight: "bold" }} primary="Invoice Date" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.invoiceDate}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>event</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-wifi"style={{ fontWeight: "bold" }} primary="Weight Date" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.createdDate}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>schedule</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-bluetooth" style={{ fontWeight: "bold" }} primary="Gross Weight" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.grossAmount} {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item md={6} xs={12}>
                            <List className={classes.root}>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>list</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-wifi"style={{ fontWeight: "bold" }} primary="Order No" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.orderNumber}
                                            </Typography>
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>assignmentReturned</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-bluetooth" style={{ fontWeight: "bold" }}primary="Product" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.product}
                                            </Typography>
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>schedule</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-bluetooth" style={{ fontWeight: "bold" }} primary="Due Date" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.dueDate}
                                            </Typography>
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>forum</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-bluetooth" style={{ fontWeight: "bold" }} primary="Measuring Unit" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"}
                                            </Typography>
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                        <Icon>schedule</Icon>
                                        </ListItemIcon>
                                        <ListItemText id="switch-list-label-bluetooth"  style={{ fontWeight: "bold" }} primary="Net Weight" />
                                        <ListItemSecondaryAction>
                                            <Typography gutterBottom>
                                            {tagNumberValues.netAmount} {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"}
                                            </Typography>
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                   
                                </List>
                            </Grid>
                            <Grid item md={2} xs={12} ></Grid>
                        </Grid>
                        </Grid>
                           
                        }
                        
                      
                        {isTableHide ? null :
                            <div className="pt-3">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Create PDF"
                                    />}
                                    content={() => componentRef.current}
                                    documentTitle={'Total Crop Report'}
                                />
                                <div hidden={true}>
                                    <CreatePDF ref={componentRef} data={tagNumberValues}
                                        searchData={selectedSearchValues} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



